/**
 * Standard API Response Types
 */
import { CadopError, CadopErrorCode } from './errors.js';
/**
 * Create a success response
 */
export const createSuccessResponse = (data) => ({
    data,
});
/**
 * Create an error response
 */
export const createErrorResponse = (message, code, details) => ({
    error: {
        message,
        code,
        details,
    },
});
/**
 * Create an error response from an error object
 */
export const createErrorResponseFromError = (error) => {
    if (error instanceof CadopError) {
        return createErrorResponse(error.message, error.code, error.details);
    }
    if (error instanceof Error) {
        return createErrorResponse(error.message, CadopErrorCode.INTERNAL_ERROR);
    }
    return createErrorResponse('Unknown error occurred', CadopErrorCode.INTERNAL_ERROR, error);
};
//# sourceMappingURL=api.js.map